import { Pipe, PipeTransform } from '@angular/core';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import * as entryUtil from '../utils/entry.util';
import { EntryType } from '@models/account/model';

@Pipe({ name: 'transactionDetails' })
export class TransactionDetailsPipe implements PipeTransform {
  public transform(data: Model.FundingAndRemittanceEntryViewModel, _args?: boolean): string {
    if (entryUtil.isRemittance(data.entryType)) {
      return `${data.paymentDetails.payeeName} Remittance`;
    }

    return data.entryType !== EntryType.ClientCABToCDAF ? 'Funds Received' : `Funding - ${data.clientCauseName}`;
  }
}
